import React from "react";
import { Building, ThumbsUp, Award, CheckCircle } from "lucide-react";
import ChimneymainImg from '../../img/about-chimney-img.jpg';

const HomeAboutUs = () => {
    return (
        <section className="hob-aboutus-section">
            <div className="hob-aboutus-container">
                <div className="hob-aboutus-left">
                    <h2 className="hob-aboutus-heading">About Us</h2>
                    <p className="hob-aboutus-text">
                        Lokesh Mandal Constructions & Engineering Pvt. Ltd. provides premium construction services across Mumbai with quality craftsmanship, modern designs, and timely project delivery. Our expertise includes residential complexes, commercial buildings, and infrastructure development with superior materials and engineering excellence. We specialize in end-to-end construction, project management, and renovation services across Maharashtra.
                    </p>

                    {/* Added unordered list with icons */}
                    <ul className="hob-aboutus-list">
                        <li><CheckCircle size={20} /> 20+ Years Experience</li>
                        <li><CheckCircle size={20} /> Growing Success</li>
                        <li><CheckCircle size={20} /> Best Service</li>
                        <li><CheckCircle size={20} /> Trusted by People</li>
                    </ul>
                </div>

                <div className="hob-aboutus-right">
                    <div className="hob-aboutus-image-wrapper">
                        <img
                            src={ChimneymainImg}
                            alt="Our Team"
                            className="hob-aboutus-image"
                        />

                        <div className="hob-aboutus-float hob-aboutus-top-right">
                            <div className="hob-aboutus-flex">
                                <Building size={18} />
                                <span>Since 2017</span>
                            </div>
                            <p className="hob-aboutus-float-desc">
                                Over 8 years of premium construction services.
                            </p>
                        </div>

                        <div className="hob-aboutus-float hob-aboutus-bottom-right">
                            <div className="hob-aboutus-flex">
                                <ThumbsUp size={18} />
                                <span>10K+ Happy Clients</span>
                            </div>
                            <p className="hob-aboutus-float-desc">
                                Trusted by thousands of satisfied clients.
                            </p>
                        </div>

                        <div className="hob-aboutus-float hob-aboutus-center-float">
                            <div className="hob-aboutus-flex">
                                <Award size={18} />
                                <span>Top-rated Builders</span>
                            </div>
                            <p className="hob-aboutus-float-desc">
                                Industry leaders in construction excellence.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HomeAboutUs;